import { useEffect, useRef } from 'react';
import { InputCheckbox } from '@components/input-checkbox';
import classNames from 'classnames';

interface CheckboxItemProps {
  id: string;
  isSelected: boolean;
  isIndeterminated: boolean;
  isDisabled?: boolean;
  description?: string;
  label: string;
  customStyles?: React.CSSProperties;
  onChange: () => void;
}

export const CheckboxItem = ({
  id,
  isSelected,
  isIndeterminated,
  isDisabled,
  onChange,
  label,
  description,
  customStyles,
}: CheckboxItemProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = isIndeterminated;
    }
  }, [isIndeterminated]);
  return (
    <fieldset
      style={customStyles}
      className={classNames('flex justify-between py-2 w-full rounded-sm', {
        'items-center': !description,
        'items-start': description,
      })}>
      <InputCheckbox
        ref={inputRef}
        id={id}
        data-testid={id}
        value={isSelected}
        disabled={isDisabled}
        onChange={onChange}
        isIndeterminated={isIndeterminated}
      />
      <label
        htmlFor={id}
        className={classNames('ml-2 w-full cursor-pointer line-clamp-2', {
          'text-subtitle-s md:text-subtitle-m': isSelected || isIndeterminated,
          'text-body-s md:text-body-m': !isSelected && !isIndeterminated,
          'text-secondary': !isDisabled,
          'text-soft': isDisabled,
        })}>
        {label}
        {description && (
          <p
            className={classNames({
              'text-subtitle-xs md:text-subtitle-s': isSelected || isIndeterminated,
              'text-body-xs md:text-body-s': !isSelected && !isIndeterminated,
            })}>
            {description}
          </p>
        )}
      </label>
    </fieldset>
  );
};
